import _ from 'lodash'
import list from './list'
import item from './item'
import form from './form'
import cargo from './cargo'

export default {
	namespaced: true,
	modules: {
		list,
		item,
		form,
		cargo,
	},
}
